import { ReceiptIcon } from "@phosphor-icons/react/Receipt";
import { Page } from "@freightsimple/ui-core/PageLayout/Page";
import { T } from "@freightsimple/ui-core/Typography/T";
import { carriersApi } from "@/App/Auth/carrierApi";
import { InvoiceAuditsTable } from "@/App/Tables/InvoiceAuditsTable";
import { CarrierLoadFailed } from "@/App/CarrierLoadFailed";
import { useCarrierFetch } from "@/App/useCarrierFetch";
import { CarrierPageLogo } from "@/App/CarrierPageLogo";

export function InvoiceAuditsView() {
  const { state, refreshing, refresh } = useCarrierFetch(() =>
    carriersApi().getCarrierInvoiceAudits(),
  );
  const audits = state.status === "loaded" ? state.data.audits : undefined;
  const waitingOnCarrier =
    audits?.filter((audit) => audit.waitingOnCarrier).length ?? 0;

  return (
    <Page
      leadingVisual={<CarrierPageLogo />}
      icon={ReceiptIcon}
      title="Invoice Audits"
      description="Shipments where your invoice is being reviewed against the quote before payment."
      fullBleed
      headerStats={
        audits
          ? [
              { label: "In Audit", value: audits.length },
              { label: "Waiting on You", value: waitingOnCarrier },
            ]
          : undefined
      }
      refreshing={refreshing}
    >
      {state.status === "loading" && (
        <T size="sm" color="secondary">
          Loading…
        </T>
      )}
      {state.status === "error" && (
        <CarrierLoadFailed what="your invoice audits" onRetry={refresh} />
      )}
      {audits && <InvoiceAuditsTable audits={audits} />}
    </Page>
  );
}
